// @core/api/endpoints/document/list_versions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListVersionsResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List versions
 * Returns the version history for any document-aware entity.
 */
export async function ListVersions(
  target_type: string,
  target_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListVersionsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/versions`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.get<ListVersionsResponse>(requestPath, { ...requestOptions, params });
}
